import httpManager from "../../../shared/utils/httpManager";

/**
 * Obtener contacto.
 *
 * @param {Number} id
 * @return {Promise<Object>} Contacto
 */
export async function fetchRecordsSequence(id) {
  const url = `/contacts/clients/${id}/sequences-history/`;
  const response = await httpManager.get(url);

  return response.data;
}
